<template>
  <div class="news">
    <p class="title">新闻动态</p>
    <div class="news-wrapper">
      <div v-for="item,index in news" :key="index" class="news-item">
        <p class="desc">{{ item.message }}</p>
        <p v-show="isFull" class="time">{{ item.updatedAt }}</p>
        <p v-show="!isFull" class="time short-time">{{ formatDate(item.updatedAt) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotification } from '@/_api/notification'

export default ({
  name: 'NewsView',
  data() {
    return {
      isFull: false,
      news: [],
    }
  },
  mounted() {
    this.getNotification()
  },
  created() {

  },
  methods: {
    formatDate(dateTimeString) {
      const date = new Date(dateTimeString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getNotification() {
      getNotification({
        page: 1,
        size: 20
      }).then((res) => {
        if (res.status == 'ok') {
          this.news = res.data.userNotifications
        }
      })
    },
  }
})
</script>

<style lang="less">
// 600px之后改成移动端
.news {
  padding: 50px;
  height: calc(100vh - 212px);
  @media screen and (max-width:650px) {
    padding: 35px;
  }
  .title {
    color: var(--head-line);
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 50px;
   
  }
  .news-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
    height: calc(100vh - 412px);
    overflow-y: scroll;
    @media screen and (max-width:650px) {
      display: block;
    }
  }
  .news-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .desc {
      text-decoration: underline;
      color: #1B2D45; 
      width: 60%;
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 隐藏溢出部分 */
      text-overflow: ellipsis; /* 显示省略号 */
    }
    .time {
      color: #868686;
      padding-right: 12px;
    }
  }
  .short-time {
    min-width: max-content;
  }
}
</style>
